import { clone } from 'lodash';

/**
 * Singleton to manage resize animation callbacks for elements.
 */
const createResizeAnimationSingleton = () => {
    const animationCallbacks = new Map();

    const registerCallback = (elementId: string, animationCallback: () => void) =>
        animationCallbacks.set(elementId, animationCallback);

    const getAnimationCallbacks = () => clone(animationCallbacks);

    const clearAnimationCallbacks = () => animationCallbacks.clear();

    return {
        registerCallback,
        getAnimationCallbacks,
        clearAnimationCallbacks,
    };
};

const resizeAnimationSingleton = createResizeAnimationSingleton();

export default resizeAnimationSingleton;
